export const VERIFICATION = {
  Verified: 'green',
  Rejected: 'red',
  'Action Required': 'amber',
  Pending: 'amber',
};
export const verificationTone = (v) => VERIFICATION[v] || 'gray';

export const DOC_LABELS = {
  aadhar: 'Aadhaar card',
  aadhar_card: 'Aadhaar card',
  pan: 'PAN card',
  pan_card: 'PAN card',
  police_verification: 'Police verification',
  bank_details: 'Bank details',
  photo: 'Photo',
  policeVerification: 'Police verification',
  bankDetails: 'Bank details',
  panCard: 'PAN card',
};
export const docLabel = (key) =>
  DOC_LABELS[key] || key.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
